// extracted by mini-css-extract-plugin
export default {"error-fallback":"styles_error-fallback__zYdJa","error-fallback-nav":"styles_error-fallback-nav__WnLkA","outer-button":"styles_outer-button__ao43w"};